"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _External = require("@jobmatchme/routing/es/provider/External");

var _Footer = _interopRequireDefault(require("@jobmatchme/landing-page-components/es/components/jmm/common/Footer"));

var _LegalFooter = _interopRequireDefault(require("@jobmatchme/profile-components/es/components/LegalFooter"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var Layout = function Layout(_ref) {
  var _ref$jmmFooter = _ref.jmmFooter,
      jmmFooter = _ref$jmmFooter === void 0 ? false : _ref$jmmFooter,
      children = _ref.children;
  var applicationRoutes = (0, _External.useApplicationRoutes)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.box,
      children: children
    }, "layoutBox"), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LegalFooter.default, {
      applicationRoutes: applicationRoutes,
      outerStyle: {
        margin: '0 auto',
        position: 'inherit'
      }
    }), jmmFooter ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {
      style: {
        marginLeft: '-16px'
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
  });
};

var _default = Layout;
exports.default = _default;